import React, { Fragment } from "react";

import { Cursor, useTypewriter } from "react-simple-typewriter";

import { SmallTitle } from "../../styles/sharedStyles"
import { ButtonAnchor } from "../ButtonAnchor/ButtonAnchor";
import{ ButtonLink } from "../ButtonLink/ButtonLink";

import {
  AnimatedText,
  DecorText,
  Icon,
  MainTitle,
  Section,
} from "./styles"

type TInfoSection = {
  hasSmallTitle?: boolean,
  hasDecorText?: boolean,
  hasOuterLink?: boolean,
  hasTypeWriter?: boolean,
  smallTitle?: string,
  backgroundImage?: string;
  buttonText: string;
  buttonLink: string;
  mainText?: string;
}

export const BannerSection: React.FC<TInfoSection> = ({
  hasSmallTitle,
  hasTypeWriter,
  backgroundImage,
  smallTitle,
  buttonText,
  buttonLink,
  mainText,
  hasDecorText,
  hasOuterLink,
}) => {

  const [text] = useTypewriter({
    words: [
      "ищешь работу заграницей",
      "нет офферов",
      "выгорание",
      "застрял и нет роста",
    ],
    loop: 0,
    typeSpeed: 50,
    deleteSpeed: 50,
  });

  return (
    <Section bgImage={backgroundImage}>
      {hasSmallTitle &&
        <SmallTitle isWhite>
          {smallTitle}
        </SmallTitle>
      }
      <MainTitle>
        {mainText}
        {hasTypeWriter && (
          <AnimatedText>
            <span>Хакнем систему найма, когда...</span>
            <br/>
            <span>
              {text}
            </span>
            <Cursor cursorStyle="|"/>
          </AnimatedText>
        )}
      </MainTitle>
      {hasDecorText &&
        <DecorText>
          <span>Делимся закрытой информацией</span>
          <Icon />
          <span>Доверительная атмосфера</span>
          <Icon />
          <span>Ориентир на личностные особенности</span>
        </DecorText>
      }
      {hasOuterLink
        ? <ButtonAnchor
          href={buttonLink}
          title={buttonText}
          hasBorder={true}
        />
        : <ButtonLink
          toPage={buttonLink}
          title={buttonText}
          hasBorder={true}
        />
      }
    </Section>
  );
};

